import WikiView from './components/theme/Views/WikiView';
import SolrSearchView from './components/theme/Views/SolrSearchView';
import NewsItemView from './components/theme/Views/NewsItemView';
import NewsContainerView from './components/theme/Views/NewsContainerView/index';
import EditUserView from './components/manage/Views/EditUserView';
import UserListingView from './components/theme/Views/UserListingView';
import DashboardView from './components/theme/Views/DashboardView';
import reducers from './reducers';
import installSlateEditor from './helpers/slateEditor';
import { PDF_WORKER_SRC } from './constants/pdf';
import { MAX_FILE_UPLOAD_SIZE } from './constants/upload';

const applyConfig = (config) => {
  config.views.contentTypesViews.Wiki = WikiView;
  config.views.contentTypesViews['News Item'] = NewsItemView;
  config.views.contentTypesViews.NewsContainer = NewsContainerView;
  // the site root has the layout dashboard_view (hornundhorn.policy), and
  // Volto picks a view by layout before it looks at the content type
  config.views.layoutViews.dashboard_view = DashboardView;
  config.views.layoutViewsNamesMapping.dashboard_view = 'Dashboard';
  // fallback for a site root without a layout, e.g. from plone.restapi 9
  config.views.contentTypesViews['Plone Site'] = DashboardView;

  config.addonRoutes.push({ path: '/search', component: SolrSearchView });
  config.addonRoutes.push({
    path: '/edit-user/:userId',
    component: EditUserView,
  });
  config.addonRoutes.push({ path: '/nutzer', component: UserListingView });

  config.addonReducers = { ...config.addonReducers, ...reducers };

  config.settings.bookmarkgroupmapping = {
    manual: 'Manuals and HowTos',
    releasenote: 'Release Notes',
    default_search: 'Search',
    default_nogroup: 'Miscellaneous',
  };
  config.settings.notSupportedBrowsers = [];
  config.settings.supportedLanguages = ['de'];
  // Volto 19 no longer reads this setting, express-middleware/language does
  config.settings.defaultLanguage = 'de';
  // pdf.js worker of the PDF block from our own server, not from a CDN (#22801)
  config.settings.pdfWorkerSrc = PDF_WORKER_SRC;
  // largest file of the mass upload, which sends files in chunks over TUS;
  // the file field of the forms stops at FORM_FILE_UPLOAD_SIZE (#22832)
  config.settings.maxFileUploadSize = MAX_FILE_UPLOAD_SIZE;

  // text editor with the links and the toolbar of the old volto-slate (#22837)
  config = installSlateEditor(config);

  // a text block inside a grid crashed the editor, new layouts use the
  // columns block; upgrade step 1110 of hornundhorn.contenttypes converts
  // the existing grids, which stay visible and editable meanwhile (#22837)
  config.blocks.blocksConfig.gridBlock.restricted = true;

  return config;
};

export default applyConfig;
